import { Component,  OnInit,Input } from '@angular/core';

@Component({
  selector: 'spinner-overlay',
  templateUrl: './spinner-overlay.component.html',
  styleUrls: ['./spinner-overlay.component.scss']
})
export class SpinnerOverlayComponent implements OnInit {

  constructor() { }
 @Input() message = '';

  ngOnInit(): void {
  }

}

